export { Icon, type IconProps, type IconName } from './Icon';
export { default } from './Icon';